import gsap from "gsap";
import { sizes } from "@/js/sizes";

export default {
	name: "TeamModule",
	data() {
		return {
			currentTeam: 0,
			allWrappers: null,
			allTitles: null,
			allDescription: null,
			tl: null,
			tlEnter: null,
			tlLeave: null,
			nextPos: 0,
			prevPos: 0,
			nextScale: 1,
			prevScale: 0.9,
			nextArrScale: 1,
			prevArrScale: 1.2,
			isMore: false,
			rotate: 40,
			content: null
		}
	},
	props: {
		modulelength: {
			type: Number
		}
	},
	created() {
		window.addEventListener('resize', this.resizeEv)

		window.addEventListener('load', () => this.setContentWrapperHeight())
	},
	mounted() {
		this.tl = gsap.timeline()
		this.getElements()
		this.setImgHeights()
		this.observeTeam()

		this.$el.addEventListener("mousemove", this.onMouseMove);
		gsap.set(this.$refs.circlenav, { rotate: this.rotate })

		this.content = document.querySelectorAll('.team__content__wrapper')[this.currentTeam]

	},
	methods: {
		setContentWrapperHeight() {
			const btnPlace = window.innerWidth < sizes.b ? 96 :
				window.innerWidth < sizes.c ? 124 :
					window.innerWidth < sizes.d ? 104 : 124

			const heights = []

			document.querySelectorAll('.team__content__wrapper').forEach(el => {
				const boldP = el.children[1].children[0]
				const firstP = el.children[1].children[1]
				const title = el.children[0]

				if (window.innerWidth < sizes.b) {
					heights.push(boldP ? boldP.clientHeight + btnPlace + title.clientHeight : 0)
				} else if (window.innerWidth > sizes.b) {
					heights.push(firstP ? boldP.clientHeight + firstP.clientHeight + btnPlace + title.clientHeight : 0)
				}

				el.children[1].children.forEach((p, i) => {
					p.style.opacity = 0

					if (window.innerWidth < sizes.b) {
						if (i === 0) p.style.opacity = 1
					} else if (window.innerWidth > sizes.b) {
						if (i === 0 || i === 1) p.style.opacity = 1
					}
				})
			})

			const height = Math.max(...heights)

			document.querySelectorAll('.team__content').forEach(el => {
				el.style.height = height + btnPlace + 'px'
			})

		},
		showMore() {
			this.isMore = !this.isMore

			if (!this.isMore) {
				this.setContentWrapperHeight()
			} else {
				const paddingTop = window.innerWidth < sizes.b ? 94 :
					window.innerWidth < sizes.c ? 106 :
						window.innerWidth < sizes.d ? 104 : 140

				document.querySelectorAll('.team__content__wrapper__description')[this.currentTeam].children.forEach(el => {
					gsap.to(el, { autoAlpha: 1, visibility: 'visible', delay: 0.3 })
				})
				document.querySelector('.team__content').style.height = paddingTop + document.querySelectorAll('.team__content__wrapper')[this.currentTeam].offsetHeight + 'px'
			}
		},
		observeTeam() {
			const teamContent = document.querySelector('.team__content');

			let optionsEnter = {
				rootMargin: "0px",
				threshold: 0.2
			}

			this.leaveAnim();

			let observerEnter = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio > 0.2 && enter.boundingClientRect.top > 0) {
						this.enterAnim()
					}
				})
			}, optionsEnter);

			observerEnter.observe(teamContent);

			let optionsLeave = {
				rootMargin: "0px",
				threshold: 0
			}

			let observerLeave = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio == 0 && enter.boundingClientRect.top > 0) {
						this.leaveAnim()
					}
				})
			}, optionsLeave);

			observerLeave.observe(teamContent);

		},
		leaveAnim() {
			this.tlLeave = gsap.timeline()

			if (this.tlEnter && this.tlEnter.isActive()) {
				this.tlEnter.kill();
			}

			if (window.innerWidth > sizes.c) {
				this.tlLeave
					.to(this.$refs.circle, { x: 100, autoAlpha: 0 })
					.to('.team__content', { x: -100, autoAlpha: 0 })
					.to(this.$refs.cont, { x: -100, autoAlpha: 0 })
					.to(this.$refs.btn, { transition: '0s', x: -100, autoAlpha: 0 })
					.to('.team__navi__dot', { autoAlpha: 0 })
			} else {
				this.tlLeave
					.to(this.$refs.circle, { y: 100, autoAlpha: 0 })
					.to('.team__content', { y: 100, autoAlpha: 0 })
					.to(this.$refs.cont, { x: -100, autoAlpha: 0 })
					.to(this.$refs.btn, { transition: '0s', y: 100, autoAlpha: 0 })
					.to('.team__navi__dot', { autoAlpha: 0 })
			}
		},
		enterAnim() {
			this.tlEnter = gsap.timeline()

			if (this.tlLeave && this.tlLeave.isActive()) {
				this.tlLeave.kill();
			}

			if (window.innerWidth > sizes.c) {
				this.tlEnter
					.to(this.$refs.circle, { x: 0, autoAlpha: 1, clearProps: 'transform' })
					.to('.team__content', { x: 0, autoAlpha: 1 }, '-=0.3')
					.to(this.$refs.cont, { x: 0, autoAlpha: 1 }, '-=0.3')
					.to(this.$refs.btn, { x: 0, autoAlpha: 1 }, '-=0.3')
					.to('.team__navi__dot', { autoAlpha: 1, stagger: 0.2 }, '-=0.3')
					.set(this.$refs.btn, { transition: '0.6s' })
			} else {
				const imgTop = window.innerWidth < sizes.b ? '-66%' : 0

				this.tlEnter
					.to(this.$refs.circle, { y: imgTop, autoAlpha: 1, clearProps: 'transform' })
					.to('.team__content', { y: 0, autoAlpha: 1 }, '-=0.3')
					.to(this.$refs.cont, { x: 0, autoAlpha: 1 }, '-=0.3')
					.to(this.$refs.btn, { y: 0, autoAlpha: 1 }, '-=0.3')
					.to('.team__navi__dot', { autoAlpha: 1, stagger: 0.1 }, '-=0.3')
					.set(this.$refs.btn, { transition: '0.6s' })
			}

		},
		resizeEv() {
			this.setImgHeights()
			this.setContentWrapperHeight()

			if (window.innerWidth < sizes.d) {
				gsap.to(this.$refs.next, { duration: 0.3, scale: this.nextScale })
				gsap.to(this.$refs.prev, { duration: 0.3, scale: this.prevScale })
			}


			const frameWidth = this.$refs.circle.offsetWidth
			gsap.set(this.$refs.imgMover, { x: -frameWidth * this.currentTeam })
			this.$refs.btn.classList.remove('var_active')



		},
		setImgHeights() {
			this.$refs.circle.style.height = this.$refs.circle.offsetWidth + 'px'

		},
		getElements() {
			this.allWrappers = document.querySelectorAll('.team__content__wrapper')
			this.allDescription = document.querySelectorAll('.team__content__wrapper__description')
			this.allTitles = document.querySelectorAll('.team__content__wrapper__name')
		},
		arrowClick(left, ev) {
			gsap.timeline()
				.to(ev.currentTarget.children[0], { duration: 0.3, x: 60 })
				.set(ev.currentTarget.children[0], { x: -30 })
				.to(ev.currentTarget.children[0], { duration: 0.3, x: 0 })


			this.changeSlideDesktop(left)
		},
		hoverIn(arr) {
			if (arr === 'next') {
				this.nextScale = 1.12
			} else {
				this.prevScale = 1.06
			}
		},
		hoverOut(arr) {
			if (arr === 'next') {
				this.nextScale = 1
			} else {
				this.prevScale = 0.9
			}
		},
		onMouseMove(ev) {
			const sliderSizes = this.$refs.circlenav.getBoundingClientRect();
			const center = sliderSizes.x + sliderSizes.width / 2;
			const isLeft = ev.clientX < center;
			const posY = (ev.clientY - sliderSizes.y) / sliderSizes.height;
			let deg = posY < 0 ? 0 : posY > 1 ? 180 : posY * 180;
			if (isLeft) {
				deg = 180 - deg;
			}
			this.rotate = Math.min(140, Math.max(40, deg));

			gsap.to(this.$refs.circlenav, { duration: 0.3, rotate: this.rotate })

		},
		onSwipe(e) {
			if (window.innerWidth > sizes.d) return
			if (e.type === 'swiperight' && this.currentTeam === 0) return
			if (e.type === 'swipeleft' && this.currentTeam === this.modulelength - 1) return
			const isLeft = e.type !== 'swipeleft'
			this.changeSlideDesktop(isLeft)
		},
		onArrowClick(left) {
			this.changeSlideDesktop(left)
		},
		onNaviClick(e) {
			this.prev = this.currentTeam
			this.currentTeam = +e.currentTarget.dataset.member

			const dir = this.currentTeam < this.prev
			this.animContentChange(dir)
		},
		changeSlideDesktop(left) {
			this.determineNextPrev(left)
			this.animContentChange(left)
		},
		determineNextPrev(left) {
			this.prev = this.currentTeam

			if (left) {
				if (!this.currentTeam) return;
				this.currentTeam -= 1
			} else {
				if (this.currentTeam === this.modulelength - 1) return;
				this.currentTeam += 1
			}

			this.animArrowOnClick(left)
		},
		animArrowOnClick(left) {
			const target = left ? this.$refs.prev : this.$refs.next

			target.children[0].style.transition = '0s'

			gsap.timeline().to(target.children[0], { x: 60, duration: 0.3 })
				.set(target.children[0], { x: -60 })
				.to(target.children[0], { x: 0, duration: 0.3, clearProps: 'transform', onComplete: () => target.children[0].style.transition = 'transform 0.3s' })
		},
		animContentChange(left) {
			if (this.tl && this.tl.isActive()) {
				this.tl.progress(1)
			}

			const dir = left ? 50 : -50
			const frameWidth = this.$refs.circle.offsetWidth

			this.tl
				.to(this.$refs.imgMover, { x: -frameWidth * this.currentTeam, ease: "power2.inOut", duration: 1, force3D: false }) // IMG
				.to(this.allDescription[this.prev], { x: dir, autoAlpha: 0, zIndex: 0, duration: 0.5, ease: "power1.inOut" }, '-=0.86') // TEXT
				.to(this.allTitles[this.prev], { x: dir, autoAlpha: 0, zIndex: 0, duration: 0.5, ease: "power1.inOut" }, '-=0.72') // TITLE
				.fromTo(this.allDescription[this.currentTeam], { x: -dir * 1.5, zIndex: 1 }, { x: 0, duration: 0.6, ease: "power1.inOut" }, '-=0.6') // TEXT
				.to(this.allDescription[this.currentTeam], { autoAlpha: 1, duration: 0.8, ease: "power1.inOut" }, '-=0.5') // TEXT
				.fromTo(this.allTitles[this.currentTeam], { x: -dir * 1.5, zIndex: 1 }, { x: 0, duration: 0.6, ease: "power1.inOut" }, '-=0.8') // TITLE
				.to(this.allTitles[this.currentTeam], { autoAlpha: 1, duration: 0.6, ease: "power1.inOut" }, '-=0.6') // TITLE

		},
	},
	watch: {
		currentTeam() {
			this.content = document.querySelectorAll('.team__content__wrapper')[this.currentTeam]
			this.setContentWrapperHeight()
			this.isMore = false

			if (window.innerWidth > sizes.b && this.content.children[1].children.length <= 2) {
				this.$refs.btn.style.opacity = 0
			} else if (this.content.children[1].children.length <= 1) {
				this.$refs.btn.style.opacity = 0
			} else {
				this.$refs.btn.style.opacity = 1
			}
		},
		isMore() {
			const btn = this.$refs.btn
			const method = this.isMore ? 'add' : 'remove'
			btn.classList[method]('var_active')
		}
	},
	beforeDestroy() {
		this.$el.removeEventListener('mousemove', this.onMouseMove)
		window.removeEventListener('resize', this.resizeEv)
		window.removeEventListener('load', () => this.setContentWrapperHeight())
	}
}
